import React, { useState } from 'react';

const InputBox = ({setOtp, otp}) => {
  // const [otp, setOtp] = useState(['', '', '', '', '', '']);

  const handleOtpChange = (e, currentIndex) => {
    const value = e.target.value;

    if (/^[0-9]*$/.test(value) && currentIndex < 6) {
      setOtp((prevOtp) => {
        const newOtp = [...prevOtp];
        newOtp[currentIndex] = value;
        return newOtp;
      });

      const nextIndex = currentIndex + 1;
      if (nextIndex < 6) {
        // If a value was entered, focus on the next box
        document.getElementById(`otp-input-${nextIndex}`).focus();
      }
    } else if (value === "" && currentIndex > 0) {
      // If the current box is empty and there is a previous box, focus on the previous box
      const prevIndex = currentIndex - 1;
      document.getElementById(`otp-input-${prevIndex}`).focus();
    }
  };

  return (
    <div>
      <h1>Enter OTP</h1>
      <div className="otp-input-container">
        {[1, 2, 3, 4, 5, 6].map((index) => (
          <input
            key={index}
            type="text"
            maxLength="1"
            value={otp[index - 1]}
            onChange={(e) => handleOtpChange(e, index - 1)}
            onFocus={(e) => e.target.select()}
            id={`otp-input-${index}`}
          />
        ))}
      </div>
    </div>
  );
};

export default InputBox;
